import { apiV2 } from '../services';
export const listAutomations = async (subdomain, _next) => {
    const res = await apiV2.twitterAutomation.listAutomations({
        params: { subdomain },
        _next,
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error('Failed to list automations');
};
export const createAutomation = async (subdomain, body) => {
    const res = await apiV2.twitterAutomation.createAutomation({
        params: { subdomain },
        body,
    });
    if (res.status === 201) {
        return res.body;
    }
    throw new Error('Failed to create automation');
};
export const updateAutomation = async (subdomain, automationId, body) => {
    const res = await apiV2.twitterAutomation.updateAutomation({
        params: { subdomain, id: automationId },
        body,
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error('Failed to update automation');
};
export const deleteAutomation = async (subdomain, automationId) => {
    const res = await apiV2.twitterAutomation.deleteAutomation({
        params: { subdomain, id: automationId },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error('Failed to delete automation');
};
export const toggleAutomation = async (subdomain, automationId, active) => {
    const res = await apiV2.twitterAutomation.toggleAutomation({
        params: { subdomain, id: automationId },
        body: { active },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error('Failed to toggle automation');
};
